import React from 'react';
import { useLocation } from 'react-router-dom';
import './ResetPassword.scss';

const ResetPassword = function init(): React.ReactElement {
    function useQuery(): URLSearchParams {
        const { search } = useLocation();
        return React.useMemo(() => new URLSearchParams(search), [search]);
    }
    const query = useQuery();
    return (
        <div>
            {query.get('foo')}
            asdasdas
        </div>
    );
};

export default ResetPassword;
